// Generated from shared source. Run work/build-uploader-shared.cjs to refresh.
export const pricing = {
    volumeTiers: [
        { min: 1, max: 4, discount: 0, label: '1–4' },
        { min: 5, max: 20, discount: 0.15, label: '5–20' },
        { min: 21, max: 100, discount: 0.2, label: '21–100' },
    ],
    print: {
        markup: 1.05,
        papers: [
            { id: 'epson-hot-press', name: 'Epson Hot Press Bright', tier: 2, maxWidth: 59 },
            { id: 'epson-cold-press', name: 'Epson Cold Press Bright', tier: 2, maxWidth: 59 },
            { id: 'moab-lasal', name: 'Moab Lasal Photo Matte', tier: 1, maxWidth: 59 },
            { id: 'photo-rag-308', name: 'Hahnemühle Photo Rag 308', tier: 3, maxWidth: 59 },
            { id: 'agave', name: 'Hahnemühle Agave', tier: 4, maxWidth: 24 },
            { id: 'epson-luster', name: 'Epson Premium Luster', tier: 1, maxWidth: 59 },
            { id: 'legacy-platine', name: 'Epson Legacy Platine', tier: 3, maxWidth: 43 },
            { id: 'photo-rag-baryta', name: 'Hahnemühle Photo Rag Baryta', tier: 4, maxWidth: 59 },
            { id: 'epson-metallic', name: 'Epson Metallic Glossy', tier: 2, maxWidth: 59 },
            { id: 'epson-premium-glossy', name: 'Epson Premium Glossy', tier: 1, maxWidth: 59 },
        ],
        tierPrices: {
            1: { 80: 18, 320: 59, 400: 73, 900: 142, 1600: 249, 2500: 385, 3600: 551 },
            2: { 80: 21, 320: 70, 400: 86, 900: 169, 1600: 296, 2500: 458, 3600: 655 },
            3: { 80: 23, 320: 77, 400: 95, 900: 187, 1600: 327, 2500: 506, 3600: 723 },
            4: { 80: 26, 320: 88, 400: 108, 900: 214, 1600: 374, 2500: 578, 3600: 827 },
        },
    },
    canvas: {
        maxWidth: 56,
        prices: { 256: 84, 576: 165, 900: 243, 1156: 303, 1296: 336, 1600: 407, 2025: 504, 2500: 612, 3136: 756 },
        stretchers: [
            { id: 'unstretched', name: 'Unstretched', rate: 0 },
            { id: 'three-quarter', name: '3/4-inch bars', rate: 0.8, maxShort: 30, maxLong: 40 },
            { id: 'one-half', name: '1 1/2-inch bars', rate: 1.05 },
        ],
    },
    mounting: {
        substrates: [
            { id: 'foam-board', name: 'Archival Foam Board', rate: 11.5, minShort: 11, minLong: 14, maxShort: 30, maxLong: 40, minimum: 25 },
            { id: 'ultra-3-16', name: 'UltraBoard 3/16-inch', rate: 11.5, minShort: 11, minLong: 14, maxShort: 48, maxLong: 72, minimum: 25 },
            { id: 'ultra-1-2', name: 'UltraBoard 1/2-inch', rate: 15.5, minShort: 11, minLong: 14, maxShort: 48, maxLong: 72, minimum: 25 },
            { id: 'dibond', name: 'Dibond', rate: 17, minShort: 16, minLong: 20, maxShort: 59, maxLong: 119, minimum: 0 },
        ],
        requiredDibondPaper: 'epson-premium-glossy',
        laminate: { rate: 11.55, markup: 1.1 },
        // Six inches deducted from EACH OVERALL dimension, not from each edge.
        rails: { dimensionReduction: 6, rate: 9.25, markup: 1.1 },
        zBar: { offset: 9, rate: 3.5, markup: 1.1 },
    },
    art: { categories: [{ max: 30, name: 'Standard', price: 150 }, { max: 47, name: 'Oversized', price: 225 }, { max: Infinity, name: 'Grand Format', price: 300 }], reflective: 60, maxShort: 50, maxLong: 90 },
    film: { formats: { '35mm': 55, medium: 75, '4x5': 95, '8x10': 295 }, addons: { cleaning: 10, unmount: 10 } },
    profiling: { none: 0, luster: 50, platine: 50, 'hot-bright': 75, 'hot-natural': 75, 'cold-bright': 75, 'cold-natural': 75, canvas: 125 },
    shipping: {
        padding: 4,
        flat: { maxShort: 13, maxLong: 19, prices: { canada: 25, usa: 30, europe: 40, intl: 50 } },
        small: { maxTube: 27, prices: { canada: 27, usa: 36, europe: 80, intl: 88 } },
        large: { maxTube: 47, prices: { canada: 42, usa: 48, europe: 95, intl: 103 } },
        additional: 5,
    },
    consulting: { hourly: 150, incrementMinutes: 15, minimumMinutes: 15, minimumPrice: 37.5, fulfilmentMinutes: 30, fulfilmentPrice: 75 },
};
// Ignore only floating-point representation noise at an integer boundary.
// For example 17.6 * 90 / 144 evaluates just above 11 in binary arithmetic.
// Values meaningfully above the boundary must still round upward.
export const ceilMeasured = (amount) => {
    const nearest = Math.round(amount);
    const tolerance = 8 * Number.EPSILON * Math.max(1, Math.abs(amount));
    return Math.abs(amount - nearest) <= tolerance ? nearest : Math.ceil(amount);
};
export const money = (amount) => ceilMeasured(amount);
export function interpolate(area, table, minimum) {
    const normalized = Math.max(area, minimum);
    const points = Object.keys(table).map(Number).sort((a, b) => a - b);
    if (table[normalized] !== undefined)
        return table[normalized];
    if (normalized <= points[0])
        return table[points[0]];
    if (normalized > points.at(-1)) {
        const last = points.at(-1);
        const previous = points.at(-2);
        return table[last] + ((table[last] - table[previous]) / (last - previous)) * (normalized - last);
    }
    const upperIndex = points.findIndex((point) => normalized <= point);
    const lower = points[upperIndex - 1];
    const upper = points[upperIndex];
    return table[lower] + ((table[upper] - table[lower]) * (normalized - lower)) / (upper - lower);
}
export function interpolationTrace(area, table, minimum) {
    const normalized = Math.max(area, minimum);
    const points = Object.keys(table).map(Number).sort((a, b) => a - b);
    if (area < minimum)
        return { method: 'minimum clamp', pricedArea: minimum, lowerArea: points[0], lowerPrice: table[points[0]], upperArea: points[0], upperPrice: table[points[0]] };
    if (table[normalized] !== undefined)
        return { method: 'exact reference point', pricedArea: normalized, lowerArea: normalized, lowerPrice: table[normalized], upperArea: normalized, upperPrice: table[normalized] };
    if (normalized > points.at(-1)) {
        const upperArea = points.at(-1);
        const lowerArea = points.at(-2);
        return { method: 'linear extrapolation', pricedArea: normalized, lowerArea, lowerPrice: table[lowerArea], upperArea, upperPrice: table[upperArea] };
    }
    const upperIndex = points.findIndex((point) => normalized <= point);
    const lowerArea = points[upperIndex - 1];
    const upperArea = points[upperIndex];
    return { method: 'linear interpolation', pricedArea: normalized, lowerArea, lowerPrice: table[lowerArea], upperArea, upperPrice: table[upperArea] };
}
export function volumeTier(quantity) {
    var _a;
    return (_a = pricing.volumeTiers.find((tier) => quantity >= tier.min && quantity <= tier.max)) !== null && _a !== void 0 ? _a : null;
}
export function calculatePrint(width, height, paperId, quantity) {
    const paper = pricing.print.papers.find((item) => item.id === paperId);
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100)
        return { error: 'Quantity must be a whole number between 1 and 100.' };
    const tier = volumeTier(quantity);
    if (!tier)
        return { error: 'No volume price is configured for this quantity.' };
    if (width <= 0 || height <= 0)
        return { error: 'Enter positive dimensions.' };
    if (Math.min(width, height) > paper.maxWidth)
        return { error: `${paper.name} has a ${paper.maxWidth}-inch maximum roll width.` };
    const area = width * height;
    const maxPricedArea = Math.max(...Object.keys(pricing.print.tierPrices[paper.tier]).map(Number));
    if (area > maxPricedArea)
        return { error: `This size exceeds the ${maxPricedArea.toLocaleString()} sq in configured price curve. Please request a custom quote.` };
    const trace = interpolationTrace(area, pricing.print.tierPrices[paper.tier], 80);
    const baseBeforeMarkup = interpolate(area, pricing.print.tierPrices[paper.tier], 80);
    const base = baseBeforeMarkup * pricing.print.markup;
    const rawUnit = base;
    const displayedUnit = money(rawUnit);
    const total = displayedUnit * quantity;
    return {
        area, paperTier: paper.tier, trace, baseBeforeMarkup, markupMultiplier: pricing.print.markup,
        markupAmount: base - baseBeforeMarkup, base, discount: 0, rawUnit, displayedUnit,
        total,
        basePerSqIn: baseBeforeMarkup / area, markedUpPerSqIn: base / area,
        discountedPerSqIn: rawUnit / area, displayedPerSqIn: displayedUnit / area,
    };
}
export function calculateCanvas(width, height, stretcherId, quantity) {
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 100)
        return { error: 'Quantity must be a whole number between 1 and 100.' };
    const tier = volumeTier(quantity);
    if (!tier)
        return { error: 'No volume price is configured for this quantity.' };
    const short = Math.min(width, height);
    const long = Math.max(width, height);
    if (width <= 0 || height <= 0)
        return { error: 'Enter positive dimensions.' };
    if (short > pricing.canvas.maxWidth)
        return { error: 'The short side exceeds the 56-inch canvas roll.' };
    const area = width * height;
    const maxPricedArea = Math.max(...Object.keys(pricing.canvas.prices).map(Number));
    if (area > maxPricedArea)
        return { error: `This size exceeds the ${maxPricedArea.toLocaleString()} sq in configured canvas price curve. Please request a custom quote.` };
    const stretcher = pricing.canvas.stretchers.find((item) => item.id === stretcherId);
    if ('maxShort' in stretcher && stretcher.maxShort && (short > stretcher.maxShort || long > stretcher.maxLong))
        return { error: '3/4-inch bars are limited to 30×40 inches.' };
    const base = interpolate(area, pricing.canvas.prices, 256);
    const stretching = 2 * (width + height) * stretcher.rate;
    const rawUnit = base + stretching;
    const displayedUnit = money(rawUnit);
    return { base, stretching, displayedUnit, total: displayedUnit * quantity };
}
export function calculateMounting(width, height, substrateId, paperId, presentation) {
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0)
        return { error: 'Enter finite, positive dimensions.' };
    const substrate = pricing.mounting.substrates.find((item) => item.id === substrateId);
    if (!substrate)
        return { error: 'Select a configured substrate.' };
    if (!['framing', 'laminate', 'float'].includes(presentation))
        return { error: 'Select a configured presentation.' };
    const short = Math.min(width, height);
    const long = Math.max(width, height);
    if (short < substrate.minShort || long < substrate.minLong || short > substrate.maxShort || long > substrate.maxLong)
        return { error: `Valid size: ${substrate.minShort}×${substrate.minLong} to ${substrate.maxShort}×${substrate.maxLong} inches.` };
    const useDibondExtras = substrateId === 'dibond';
    const forcedPaper = useDibondExtras;
    const paper = pricing.print.papers.find((item) => item.id === (forcedPaper ? pricing.mounting.requiredDibondPaper : paperId));
    if (!paper)
        return { error: 'Select a configured paper.' };
    if (short > paper.maxWidth)
        return { error: `${paper.name} has a ${paper.maxWidth}-inch maximum roll width.` };
    const area = width * height;
    const sqft = ceilMeasured(area / 144);
    const maxPrintArea = Math.max(...Object.keys(pricing.print.tierPrices[paper.tier]).map(Number));
    // A valid substrate size does not establish a paper price outside its curve.
    const printQuoteReason = area > maxPrintArea ? `Printing above ${maxPrintArea.toLocaleString()} sq in needs a custom quote. The mounting-only price below excludes printing.` : null;
    const paperCost = printQuoteReason ? null : interpolate(area, pricing.print.tierPrices[paper.tier], 80) * pricing.print.markup;
    const substrateCost = Math.max(substrate.minimum, sqft * substrate.rate);
    const laminate = useDibondExtras && presentation !== 'framing' ? sqft * pricing.mounting.laminate.rate * pricing.mounting.laminate.markup : 0;
    const railFeet = useDibondExtras && presentation === 'float' ? Math.max(0, ceilMeasured((2 * (width - pricing.mounting.rails.dimensionReduction) + 2 * (height - pricing.mounting.rails.dimensionReduction)) / 12)) : 0;
    const rails = railFeet * pricing.mounting.rails.rate * pricing.mounting.rails.markup;
    const zBarFeet = useDibondExtras && presentation === 'float' ? Math.max(1, ceilMeasured((long - pricing.mounting.zBar.offset) / 12)) : 0;
    const zBar = zBarFeet * pricing.mounting.zBar.rate * pricing.mounting.zBar.markup;
    const mountingSubtotal = substrateCost + laminate + rails + zBar;
    const rawTotal = paperCost === null ? null : paperCost + mountingSubtotal;
    const total = rawTotal === null ? null : money(rawTotal);
    return { sqft, paperId: paper.id, paperCost, substrateCost, laminate, railFeet, rails, zBarFeet, zBar, mountingSubtotal, mountingOnlyTotal: money(mountingSubtotal), rawTotal, total, printQuoteReason };
}
export function calculateArt(width, height, reflective, profile) {
    if (width <= 0 || height <= 0)
        return { error: 'Enter positive dimensions.' };
    const short = Math.min(width, height);
    const long = Math.max(width, height);
    if (short > pricing.art.maxShort || long > pricing.art.maxLong)
        return { error: 'In-studio capture is limited to 50×90 inches.' };
    const category = pricing.art.categories.find((item) => long <= item.max);
    const total = category.price + (reflective ? pricing.art.reflective : 0) + pricing.profiling[profile];
    return { category: category.name, base: category.price, total: money(total) };
}
export function calculateFilm(format, quantity, cleaning, unmount, profile) {
    if (!Number.isInteger(quantity) || quantity < 1)
        return { error: 'Quantity must be a whole number of at least 1.' };
    const formatPrice = pricing.film.formats[format];
    const addons = (cleaning ? pricing.film.addons.cleaning : 0) + (unmount && format === '35mm' ? pricing.film.addons.unmount : 0);
    return { perFrame: formatPrice + addons, total: money((formatPrice + addons) * quantity + pricing.profiling[profile]) };
}
export function calculateShipping(width, height, quantity, destination) {
    if (!Number.isInteger(quantity) || quantity < 1)
        return { error: 'Quantity must be a whole number of at least 1.' };
    if (width <= 0 || height <= 0)
        return { error: 'Enter positive dimensions.' };
    const short = Math.min(width, height);
    const long = Math.max(width, height);
    let packageName = '';
    let base = 0;
    if (short <= pricing.shipping.flat.maxShort && long <= pricing.shipping.flat.maxLong) {
        packageName = 'Flat Pack';
        base = pricing.shipping.flat.prices[destination];
    }
    else {
        const tube = short + pricing.shipping.padding;
        if (tube <= pricing.shipping.small.maxTube) {
            packageName = 'Tube small';
            base = pricing.shipping.small.prices[destination];
        }
        else if (tube <= pricing.shipping.large.maxTube) {
            packageName = 'Tube large';
            base = pricing.shipping.large.prices[destination];
        }
        else
            return { packageName: 'Custom Quote', total: null, tubeLength: tube };
    }
    return { packageName, base, total: money(base + (quantity - 1) * pricing.shipping.additional), tubeLength: short + pricing.shipping.padding };
}
